module.exports = __webpack_public_path__ + "img/CCCS.c59dc9ff.png";